package com.schoolconnect.app.feature.homework

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import com.schoolconnect.app.feature.common.PaginationPolicy

data class ParentHomeworkUiState(
    val isLoading: Boolean = true,
    val errorMessage: String = "",
    val searchQuery: String = "",
    val status: String = "All",
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val rows: List<HomeworkRowUi> = emptyList(),
    val open: Int = 0,
    val dueSoon: Int = 0,
    val dueToday: Int = 0,
    val closed: Int = 0,
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val totalCount: Int = 0,
    val sortField: ParentHomeworkSortField = ParentHomeworkSortField.HOMEWORK,
    val sortAscending: Boolean = true,
    val viewingHomework: HomeworkRowUi? = null,
    val isViewingLoading: Boolean = false,
    val viewingError: String = ""
) {
    val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex)
}

sealed interface ParentHomeworkUiEvent {
    data class ChildSelected(val index: Int) : ParentHomeworkUiEvent
    data class SearchChanged(val value: String) : ParentHomeworkUiEvent
    data class StatusChanged(val value: String) : ParentHomeworkUiEvent
    data object FiltersReset : ParentHomeworkUiEvent
    data class PageChanged(val index: Int) : ParentHomeworkUiEvent
    data class PageSizeChanged(val size: Int) : ParentHomeworkUiEvent
    data class SortChanged(val field: ParentHomeworkSortField) : ParentHomeworkUiEvent
    data class ViewRequested(val row: HomeworkRowUi) : ParentHomeworkUiEvent
    data object ViewDismissed : ParentHomeworkUiEvent
    data object Refresh : ParentHomeworkUiEvent
}

enum class ParentHomeworkSortField { HOMEWORK, CLASS, SUBJECT, ASSIGNED_BY, ASSIGNED_DATE, DUE_DATE, STATUS }
